import React, { useEffect, useState } from "react";
import { Box } from "@material-ui/core";
import { DisplayFieldSameLine } from "../../util/DisplayField";

export const MineAssetDescription = (props: { mineAsset: MiningAsset | null }) => {
  const { mineAsset } = props;

  // TODO: define a type when we know what we want to display
  const [mineAssetSpecialDetails, setMineAssetSpecialDetails] = useState<any>({});

  useEffect(() => {
    if (mineAsset) {
      const specialDetailsObj = JSON.parse(mineAsset.specialDetails);
      setMineAssetSpecialDetails(specialDetailsObj);
    }
  }, [mineAsset]);

  return (
    <Box p={1}>
      {/* <DisplayField label="Name" value={mineAsset?.name} />
      <DisplayField label="Country" value={mineAsset?.country} />
      <DisplayField label="Owner" value={mineAsset?.owner} /> */}

      {Object.keys(mineAssetSpecialDetails).map((field, index) => (
        <DisplayFieldSameLine key={index} label={field} value={mineAssetSpecialDetails[field]} />
      ))}
    </Box>
  );
};
